import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import { ConfirmPopComponent } from '../confirm-pop/confirm-pop.component';
import { MesaDeAyudaService } from '../../services/mesa-de-ayuda.service';

import {environment} from '../../../environments/environment';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-mis-tickets',
  templateUrl: './mis-tickets.component.html',
  styleUrls: ['./mis-tickets.component.css'],
  providers: [UserService, MesaDeAyudaService]
})
export class MisTicketsComponent implements OnInit {
  public sessionActive: boolean;
  public message: string;
  public status: string;
  public tickets = [];

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private mesaDeAyudaService: MesaDeAyudaService,
  ) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
    this.getTickets();
  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }


  getTickets() {
    this.mesaDeAyudaService.getMisTickets().subscribe(response => {
      console.log(response);
      if (response.status) {
        this.tickets = response.tickets;
      } else {
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });

  }

}
